export default __webpack_public_path__ + "static/media/logo.37b3d63f.png";